import { FakeCompanyId } from 'webapp/components/goal/inline-group';

import type { FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import type { FilterOption } from 'webapp/models-custom/filter-sort/filter';
import FilterSortGoal from 'webapp/models-custom/filter-sort/goal';
import type Goal from 'webapp/models-custom/goal';

export const viewSettingsNamePrefix = 'goalsOKRsViewSettings';
export const settingsNamePrefix = 'goalsOKRsFilterSettings'; // used to save filter preferences

export default abstract class FilterSortGoalOKRs extends FilterSortGoal {
	viewSettingsNamePrefix = viewSettingsNamePrefix;
	settingsNamePrefix = settingsNamePrefix;

	constructor(options: FilterSortSettings<Goal>) {
		super(options);

		this.createFilters();
	}

	override get viewOptions(): FilterOption<string>[] {
		return [
			{ id: 'table', text: 'List view', icon: 'List' },
			{ id: 'grid', text: 'Strategy map', icon: 'TreeMap' },
		];
	}

	createFilters(): void {
		const selectedFilters = this.readSavedSelectedFilters();

		this.createTimeframeFilter(selectedFilters);

		this.createFilter<string>({
			id: 10,
			label: 'Team',
			name: 'team',
			selected: selectedFilters[10] as string | undefined,
			stringValues: true,
			isMultiSelect: true,
			getOptions: () => {
				return this.groupOptions;
			},
			filterFn: function (item, selected) {
				return selected.some((selectedValue) => {
					if (selectedValue === FakeCompanyId) {
						return !item.groupId;
					}

					return item.groupId === selectedValue;
				});
			},
		});

		this.createFilter<number>({
			id: 7,
			label: 'Status',
			name: 'status',
			selected: selectedFilters[7] as number | undefined,
			isMultiSelect: true,
			getOptions: () => {
				return this.statusOptions;
			},
			filterFn: (item, selected) => {
				return selected.some(
					(selectedValue) =>
						item.hierarchyDataModelWithFallback?.status === selectedValue,
				);
			},
		});
	}
}
